/* eslint-disable hum/require-constants-import */
/* eslint-disable hum/restrict-constants-imports */
import { getPeriodOptions } from "../helpers/getPeriodThresholds";
import { PeriodCategory, PeriodResolution } from "../Metrics.types";

export const HISTORICAL_PERIOD_CATEGORIES: PeriodCategory[] = [
    {
        id: PeriodResolution.MONTHLY,
        label: "Monthly",
        options: getPeriodOptions(PeriodResolution.MONTHLY),
    },
    {
        id: PeriodResolution.QUARTERLY,
        label: "Quarterly",
        options: getPeriodOptions(PeriodResolution.QUARTERLY),
    },
    {
        id: PeriodResolution.YEARLY,
        label: "Annual",
        options: getPeriodOptions(PeriodResolution.YEARLY),
    },
];
